var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCollectionIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector1",
    d: "M7.35,14.63c-.54.14-1.11.07-1.59-.21-.48-.28-.83-.74-.98-1.27l-1.55-5.8c-.14-.54-.07-1.11.21-1.59.28-.48.74-.83,1.27-.98l5.8-1.55c.54-.14,1.11-.07,1.59.21.48.28.83.74.98,1.27l.76,2.83.03.11h1.86l-.05-.19-.86-3.22c-.13-.5-.36-.96-.67-1.37-.31-.41-.7-.75-1.14-1-.44-.26-.93-.42-1.44-.49-.51-.07-1.02-.03-1.52.1l-5.79,1.55c-.49.13-.96.36-1.37.67-.41.31-.75.7-1,1.14-.26.44-.42.93-.49,1.44-.06.44-.04.9.06,1.33l.04.19,1.55,5.79.05.18c.28.87.86,1.63,1.64,2.12.83.52,1.83.71,2.8.53l.12-.02v-1.86l-.19.05-.11.03Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector2",
    d: "M21.73,9.77c-.59-.59-1.39-.92-2.23-.92h-7.5c-.84,0-1.64.33-2.23.92-.59.59-.92,1.39-.92,2.23v7.5c0,.84.33,1.64.92,2.23.59.59,1.39.92,2.23.92h7.5c.84,0,1.64-.33,2.23-.92.59-.59.92-1.39.92-2.23v-7.5c0-.84-.33-1.64-.92-2.23ZM10.65,12c0-.36.14-.7.4-.96.25-.25.6-.4.95-.4h7.5c.36,0,.7.14.96.4.25.25.4.6.4.96v7.5c0,.36-.14.7-.4.95-.25.25-.6.4-.96.4h-7.5c-.36,0-.7-.14-.95-.4-.25-.25-.4-.6-.4-.95v-7.5Z",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollectionIcon);
export default __webpack_public_path__ + "static/media/CollectionIcon.a01d802435583c10c1ebadeeaa67cb9b.svg";
export { ForwardRef as ReactComponent };